<template>
  <div v-if="currentRouteName !== 'Login' && currentRouteName !== null">
<!--  <v-app-bar-->
<!--    class="elevation-1"-->
<!--    app-->
<!--    :color="$vuetify.theme.dark ? 'dark' : '#fff'"-->
<!--    fixed>-->
    <v-app-bar
      class="elevation-1"
      app
      :color="$store.state.theme_mixed || $vuetify.theme.dark ? 'dark' : '#fff'"
      :dark="$store.state.theme_mixed"
      fixed>
    <v-btn
      icon
      color="#CF112D"
      @click="logOut()"
      dense
    >
      <v-icon dense color="red">mdi-power-standby</v-icon>
    </v-btn>


    <v-toolbar-title v-text="$route.name" class="ml-10 toolbar"/>
    <v-spacer/>
    <v-img
      @dblclick="dialog = true"
      v-if="$store.state.special_day === true && specialDayName === 'Navidad'"
      :lazy-src="$store.state.theme_mixed || $vuetify.theme.dark ? require('@/assets/logoCab-B-dark-christmas.png') : require('@/assets/logoCab-christmas.png')"
      max-height="83"
      max-width="216"
      :src="$store.state.theme_mixed || $vuetify.theme.dark ? require('@/assets/logoCab-B-dark-christmas.png') : require('@/assets/logoCab-christmas.png')"
    ></v-img>
    <v-img
      @dblclick="dialog = true"
      v-else
      :lazy-src="$store.state.theme_mixed || $vuetify.theme.dark ? require('@/assets/logoCab-B-dark.png') : require('@/assets/logoCab.png')"
      max-height="83"
      max-width="216"
      :src="$store.state.theme_mixed || $vuetify.theme.dark ? require('@/assets/logoCab-B-dark.png') : require('@/assets/logoCab.png')"
    ></v-img>
  </v-app-bar>
  <v-dialog
    v-model="dialog"
    width="600px"
    :dark="$store.state.theme_mixed || $vuetify.theme.dark"
  >
    <v-card
      elevation="2">
      <v-card-title align="center" justify="center" align-center justify-center>
        <v-img
          @dblclick="dialog = true"
          v-if="$store.state.special_day === true && specialDayName === 'Navidad'"
          :lazy-src="$store.state.theme_mixed || $vuetify.theme.dark ? require('@/assets/logoCab-B-dark-christmas.png') : require('@/assets/logoCab-christmas.png')"
          :src="$store.state.theme_mixed || $vuetify.theme.dark ? require('@/assets/logoCab-B-dark-christmas.png') : require('@/assets/logoCab-christmas.png')"
          ></v-img>
        <v-img
          @dblclick="dialog = true"
          v-else
          :lazy-src="$store.state.theme_mixed || $vuetify.theme.dark ? require('@/assets/logoCab-B-dark.png') : require('@/assets/logoCab.png')"
          :src="$store.state.theme_mixed || $vuetify.theme.dark ? require('@/assets/logoCab-B-dark.png') : require('@/assets/logoCab.png')"
          ></v-img>
      </v-card-title>
      <v-card-subtitle align="center" justify="center" >
        <h3 class="mb-5 mt-5" ><span>v{{ version }}</span></h3>
      </v-card-subtitle>
      <v-card-text class="mt-n6" align="center" justify="center">
        <v-row
          class="pa-4"
          justify="space-between"
        >
        <v-col
          class="d-flex text-left"
        >

          {{ `- server: \t ${backend.server}` }}<br>
          {{ `- version: \t ${backend.version}` }}<br>
          {{ `- last_modified: \t ${backend.last_modified}` }}<br>
          {{ `- Data Model: \t ${datamodel}` }}<br>
          {{ `- Worker: \t ${worker}` }}<br>
          {{ `- python: \t ${backend.python}` }}
        </v-col>
        <v-divider vertical></v-divider>

        <v-col
          class="d-flex text-left"
        >
          {{ `- system: \t ${backend.system}` }}<br>
          {{ `- tornado: \t ${backend.tornado}` }}<br>
          {{ `- ssl: \t ${backend.ssl}` }}<br>
          {{ `- uvloop: \t ${backend.uvloop}` }}<br>
          {{ `- openpyxl: \t ${backend.openpyxl}` }}<br>
          {{ `- fdpf2: \t ${backend.fdpf2}` }}<br>

        </v-col>
        </v-row>



      </v-card-text>
      <v-card-text class="mt-n6" align="center" justify="center">
        <v-divider></v-divider>
        <strong>Desarrollado por Lawrence, Francisco y Juan 👨🏻‍💻 </strong><br>
        <strong>Chile - {{ new Date().getFullYear() }} </strong>
      </v-card-text>

    </v-card>
  </v-dialog>
  </div>
</template>
<script>
// import {Role} from '@/js/roles'
import {authentication} from '@/js/authentication'
import Vue from "vue";
import { version as worker_version } from '@/js/ws_worker'
import { version as data_model_version } from '@/js/cyb_data_model'
import {searchDay} from "@/js/specialDay";

export default {
  name: '_topbar',
  data() {
    return {
      worker: worker_version,
      datamodel: data_model_version,
      version: '',
      dialog: false,
      colorHead: this.$vuetify.theme.dark ? 'dark' : '#fff',
      devs: false,
      user: null,
      avatar: null,
      color: this.$vuetify.theme.dark ? '#DDD' : '#212121',
      logout_icon: 'mdi-logout-variant',
      home: 'mdi-home-outline',
      specialDayName: '',
      url_version: "https://" + location.host + "/api/version",
      backend: {}
    }
  },
  watch: {
    '$store.state.special_day'() {
      this.specialDayName = searchDay()
    }
  },
  beforeCreate() {
    if (this.$vuetify.theme.dark) {
      document.querySelector('body').setAttribute('style', 'background:#272727')
    } else {
      document.querySelector('body').setAttribute('style', 'background:#fffffe')
    }
  },
  methods: {
    logOut() {
      authentication.logout()
      this.$router.push({path: '/'})
    },
    async getVersions(){
      const response = await fetch(this.url_version);
      this.backend = await response.json();
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    }
  },
  created() {
  },
  async mounted() {
    this.specialDayName = searchDay()
    document.body.style.setProperty('--main-color', this.color)
    this.devs = Vue.prototype.$devs.status
    this.version = Vue.prototype.$devs.version
    await this.getVersions()
  }
}
</script>

<style scoped lang="scss">

</style>
